









































































































































































































































































































































































import { Routes } from "@/router/Routes";
import { BreadCrumb } from "@/store/modules/GlobalStore";
import { inForceStore } from "@/store/modules/InForceStore";
import { Component } from "vue-property-decorator";
import InForceBase from "../base/InForceBase";
import { Route } from "vue-router";
import _ from "lodash";
import { AnnuityType } from "@/enums/AnnuityType";
import { Pages } from "@/enums/Pages";

@Component
export default class extends InForceBase {
  page = Pages.ANNUITY_DETAIL;
  title = "Existing Business Annuity Details";
  breadCrumbs = [
    new BreadCrumb("Existing Policies", { name: Routes.EXISTING_BUSINESS }),
  ];
  notification = "";
  panel = [0, 1, 2];
  dialog = false;

  async beforeRouteEnter(
    to: Route,
    from: Route,
    next: () => void
  ): Promise<void> {
    await inForceStore.select(to.params.id);
    next();
  }
  created(): void {
    this.title = `Existing Business Annuity Details`;
    if (inForceStore.current.policyNumber !== null) {
      this.breadCrumbs.push(
        new BreadCrumb(`Policy Number - ${inForceStore.current.policyNumber}`)
      );
    }
    const notificationArray = [];
    if (this.state.surrenderExpiring) {
      notificationArray.push("Surrender Expiring");
    }
    if (this.state.surrenderExpired) {
      notificationArray.push("Surrender Expired");
    }
    if (this.state.nearingRetirement) {
      notificationArray.push("Nearing Retirement");
    }
    if (this.state.requiredMinimumDistribution) {
      notificationArray.push("Required Minimum Distribution");
    }
    if (this.state.marketValueAdjustment) {
      notificationArray.push("Market Value Adjustment");
    }
    this.notification = _.join(notificationArray, ", ");
  }
  get totalSurrenderExpiring(): number {
    return inForceStore.totalSurrenderExpiring;
  }
  get totalSurrenderExpired(): number {
    return inForceStore.totalSurrenderExpired;
  }

  get totalRequiredMinimumDistribution(): number {
    return inForceStore.totalRequiredMinimumDistribution;
  }
  get AnnuityTypeName(): string {
    if (this.state.productCategory === "FA") {
      return AnnuityType.FA;
    } else if (this.state.productCategory === "EIA") {
      return AnnuityType.EIA;
    } else if (this.state.productCategory === "SPIA") {
      return AnnuityType.SPIA;
    }
    return "";
  }
}
